import { useNavigate } from "react-router-dom";
import logo from "../../../assets/images/logo.png";

const NavbarSettings = () => {
  const navigate = useNavigate();
  
  return (
    <nav className="sticky top-0 z-50 w-full bg-primary-dark shadow-lg">
      <div className="flex items-center justify-between px-3 sm:px-5 pt-2 pb-2">
        <button 
          onClick={() => navigate("/dashboard")}
          className="flex items-center gap-2 sm:gap-3 cursor-pointer hover:opacity-80 transition-opacity"
        >
          <img
            src={logo}
            alt="Cloud Icon"
            className="w-8 sm:w-10 md:w-12 pt-2 sm:pt-3 md:pt-4 pb-2 sm:pb-3 md:pb-4 object-contain brightness-0 invert"
          />
          <div className="text-white text-xl sm:text-2xl md:text-3xl font-bold leading-tight">
            Sindi<span className="text-primary-cyan">Board</span>
          </div>
        </button>
      </div>
    </nav>
  );
};

export default NavbarSettings;